function NameVerification() {
    return (
        <div>
            <h2>Name Verification</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default NameVerification;